import { render, staticRenderFns } from "./MypageTopDownloadHistory.vue?vue&type=template&id=400db934&"
import script from "./MypageTopDownloadHistory.vue?vue&type=script&lang=ts&"
export * from "./MypageTopDownloadHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports